import * as React from "react"
import * as styles from '../styles/product_details_section.module.css'
import { Header1, Header2 } from "./heading_elements";

export function ProductDetailsSection() {
    return (
        <section className={styles.section_product_details}>
          <Header1 headerTitle={"製品情報"}></Header1>
          <div className={styles.product_detail}>
            <Header2 headerTitle={"ジャンル"}/>
            <div className={styles.text}>現代ファンタジーADV</div>
          </div>
          <div className={styles.product_detail}>
            <Header2 headerTitle={"料金体系"}/>
            <div className={styles.text}>基本無料＋有料DLC</div>
          </div>
          <div className={styles.product_detail}>
            <Header2 headerTitle={"プレイ人数"}/>
            <div className={styles.text}>１人用</div> 
          </div>
          <div className={styles.product_detail}>
            <Header2 headerTitle={"対応プラットフォーム"}/>
            <div className={styles.text}>Steam</div>
          </div>
          <div className={styles.product_detail}>
            <Header2 headerTitle={"対応OS"}/>
            <div className={styles.text}>Windows</div>
          </div>
          <div className={styles.product_detail}>
            <Header2 headerTitle={"対応予定言語"}/>
            <div className={styles.text}>日本語・英語・中国語</div>
          </div>
        </section>
    )
  }
  